import { EllipseMarker } from "@markerjs/markerjs3";

export default class DotMarker extends EllipseMarker {
	static typeName = "DotMarker";
	static title = "Dot Marker";
	private readonly initialSize: number = 32;
	private initialized: boolean = false;

	constructor(container: SVGGElement) {
		super(container);
		this.width = 32;
		this.height = 32;
	}

	protected getPath(width?: number | undefined, height?: number | undefined): string {
		const path = super.getPath(width, height);
		this.initialized = true;
		return path;
	}
}
